
(function(template){
define('vue!app/views/vue/components/cartComponent/addGuestComponent/groupMemberDropdown',['Vue','vuex'],function(Vue,vuex){
    return {
        template: template,
        data: function(){
            return {
                showMembers: false,
            }
        },
        computed: _.extend( vuex.mapState(['users','groupMembers','desktopMode','loggedInUser','showMobileItineraryDropDown']),{
            remainingGroupMembers: function(){
                var vm = this;
                return vm.groupMembers.filter(function(member){ return Object.keys(vm.users).indexOf(member)==-1 })
            }
        }),
        methods: {
            handleClick: function(){
                this.showMembers = !this.showMembers;
                this.$store.commit("setIsBodyBlur", this.showMembers)
               this.$store.commit('setShowMobileItineraryDropDown',false)
            },
            handleAdd: function(){
               
               this.$emit('toggle-Show-Add',true)
            },
            handleSelect: function(member){
                  if(Object.keys(this.users).indexOf(member)>-1){
                    this.$store.commit('removeGuestMember',{userId:member});
                  }
                  else{
                      this.$store.commit('addUser',member); 
                  }
            },
            hide: function(){
               if(this.showMembers == true) this.showMembers = false;
                
            },
            test:function(){
                vm = this
              console.log("test with group",   vm.groupMembers.filter(function(member){ return Object.keys(vm.users).indexOf(member)==1 }
              ))},
            isGroupMemberAdded:function(member,index){
                 if(Object.keys(this.users).indexOf(member)>-1){
                return true
                }
            }
        },
        watch: {
            showMembers:function(val){
                  this.$store.commit("setIsBodyBlur", val)
                 
            }
        }
    }
})
})('<div class="cart-user pointer" v-click-outside="hide"> <div v-if="desktopMode" class="cart-user-header group-member-dropdown" :class="showMembers ? \'curved-top\' : null" v-on:click="handleClick"> <i class="icon-user icon-white"></i> <span>{{localStrings.groupMemberList.title}}</span> <i :class="showMembers ? \'icon-chevron-up\' : \'icon-chevron-down\'" class="icon-white right"></i> </div> <i v-else class="fas fa-user-plus login-mobile-icon" :class="!showMembers ? \'curved-top\' : null" v-on:click="handleClick"></i> <div class="cart-user-body" v-show="showMembers"> <div @click="test" class="group_title">{{localStrings.groupMemberList.title}}</div> <div class="member-item pointer" ><div class="custom-check-box checked disabled"><i class="icon-ok icon-white"></i></div><span>{{ loggedInUser }}</span></div> <div class="member-item pointer" v-for="(member,index) in groupMembers" :key="index" v-on:click="handleSelect(member)"><div class="custom-check-box" :class="isGroupMemberAdded(member,index)? \'checked\':null"><i v-show="isGroupMemberAdded(member,index)" class="icon-ok icon-white"></i></div><span>{{ member }}</span></div> <div class="member-item pointer" v-on:click="handleAdd">{{localStrings.groupMemberList.addMoreText}}</div> </div> </div>');
